import { AxiosRequestConfig, AxiosResponse, AxiosInstance } from 'axios';

import { applyLinkedCollections, camelToSnakeCaseParams, toQueryString } from '../utilities';

type Options = {
  fetchAuthToken: (refresh?: boolean) => Promise<string>;
  disableParamMutation?: boolean;
}

export function applyAxiosMiddleware(axios: AxiosInstance, options: Options) {
  const { fetchAuthToken, disableParamMutation } = options;

  // Serialize query params:
  axios.defaults.paramsSerializer = toQueryString;

  if (!disableParamMutation) {
    axios.interceptors.request.use((config: AxiosRequestConfig) => {
      config.params = camelToSnakeCaseParams(config.params);
      config.data = camelToSnakeCaseParams(config.data);
      return config;
    });
  }

  // Handle request authentication:
  axios.interceptors.request.use(async (config: AxiosRequestConfig) => {
    if (config.headers) {
      config.headers.Authorization = await fetchAuthToken();
    }
    return config;
  });

  // Map linked records:
  axios.interceptors.response.use((response: AxiosResponse<any>) => {
    applyLinkedCollections(response.data);
    return response;
  });

  // TODO: Notify bugsnag on error
  // Handle refresh token:
  axios.interceptors.response.use(res => res, async err => {
    const status = err.response ? err.response.status : null;
    if (status === 401) {
      err.config.headers.Authorization = await fetchAuthToken(true);
      return axios.request(err.config);
    }
    return Promise.reject(err);
  });
}
